import {
  Ecommerce,
  GetOrdersProducts,
  GetSingleOrder,
  Login,
  MerchantAddress,
  MerchantCategory,
  MerchantEcommercePathway,
  MerchantPages,
  MerchantProduct,
  MerchantSetting,
  VerifyOTP,
} from "utils/URLs";
import { get, getWithoutHeader, postWithoutHeader } from "utils/v2/api";

export const login = (data: any) => postWithoutHeader(`${Login}`, data);
export const getMerchantDetails = () => get(`${MerchantSetting}`);

export const getMerchantEcommerce = (data: any) =>
  getWithoutHeader(`${Ecommerce}/${data}`);
export const getMerchantEcommercePathway = (data: any) =>
  getWithoutHeader(`${MerchantEcommercePathway}/${data}`);
export const getMerchantAddress = (data: any) =>
  getWithoutHeader(`${MerchantAddress}/${data}`);
export const getSingleOrder = (data: any) =>
  getWithoutHeader(`${GetSingleOrder}/${data}`);
export const getSingleOrderProduct = (data: any) =>
  getWithoutHeader(`${GetOrdersProducts}/${data}`);
export const getMerchantSetting = (data: any) =>
  getWithoutHeader(`${MerchantSetting}/${data}`);
export const getMerchantProduct = (data: any) =>
  getWithoutHeader(`${MerchantProduct}/${data}`);
export const getMerchantCategory = (data: any) =>
  getWithoutHeader(`${MerchantCategory}/${data}`);
export const getMerchantPages = (data: any) =>
  getWithoutHeader(`${MerchantPages}/${data}`);
export const onVerifyOtp = (data: any) => postWithoutHeader(`${VerifyOTP}`, data);